export default __webpack_public_path__ + "media/zurb/img/ecommerce/shopping_flow3-7ee18601cf9706f7a068e5f8fb918a36.png";